import { useTranslation } from '@packages/utils';
import useGetValidationData from 'components/Base/Form/validationRules';
import { EAttendanceType } from 'data/types/events.types';

export const keyPrefix =
  'descriptions.admin-portal.events.list.actions.create-event.modal.form';

const useGetData = () => {
  const { validationRules } = useGetValidationData();
  const { t } = useTranslation();

  const attendanceTypeOptions = Object.values(EAttendanceType).map(item => ({
    value: item,
    label: t(`enums.attendance-type.${item}`),
  }));

  const numberOfDaysOptions = [
    {
      value: 1,
      label: '1 Day',
    },
    {
      value: 2,
      label: '2 Days',
    },
    {
      value: 3,
      label: '3 Days',
    },
  ];

  const hostTypeOptions = [
    {
      value: 'ORGANIZATION',
      label: 'Organizations',
    },
    {
      value: 'ELC',
      label: 'ELCs',
    },
  ];

  const createEventFormFields = {
    type: {
      name: 'type',
      label: t(
        'descriptions.admin-portal.events.list.actions.create-event.modal.form.event.LABEL',
      ),
      placeholder: t(
        'descriptions.admin-portal.events.list.actions.create-event.modal.form.event.PLACEHOLDER',
      ),
      rules: [validationRules.requiredField()],
    },
    title: {
      name: 'title',
      label: t('Title'),
      placeholder: 'Enter Name',
      rules: [validationRules.requiredField()],
    },
    host: {
      name: 'host',
      label: t(
        'descriptions.admin-portal.events.list.actions.create-event.modal.form.host.LABEL',
      ),
      placeholder: 'Select Host',
      rules: [validationRules.requiredField()],
    },
    attendanceType: {
      name: 'attendanceType',
      label: t(
        'descriptions.admin-portal.events.list.actions.create-event.modal.form.attendance-type.LABEL',
      ),
      options: attendanceTypeOptions,
      initialValue: EAttendanceType.IN_PERSON,
      rules: [validationRules.requiredField()],
    },
    numberOfDays: {
      name: 'numberOfDays',
      label: 'Number of event days',
      options: numberOfDaysOptions,
      initialValue: 1,
      rules: [validationRules.requiredField()],
    },
    requiresRegistration: {
      name: 'requiresRegistration',
      label: 'Event requires registration',
      initialValue: false,
    },
  };

  return { createEventFormFields, hostTypeOptions };
};

export default useGetData;
